import { render } from "./Switch.vue?vue&type=template&id=5d10fb8c"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/Switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d10fb8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d10fb8c', __exports__)) {
    api.reload('5d10fb8c', __exports__)
  }
  
  module.hot.accept("./Switch.vue?vue&type=template&id=5d10fb8c", () => {
    api.rerender('5d10fb8c', render)
  })

}


export default __exports__